var _style, _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJudgeUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.07951,
    y: 9.07975,
    width: 43.841,
    height: 43.841,
    rx: 10,
    ry: 10,
    transform: "translate(-13.13369 30.29297) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.70735,
    y: 8.38633,
    width: 40.58535,
    height: 40.58535,
    rx: 10,
    ry: 10,
    transform: "translate(-11.49231 29.61311) rotate(-45)",
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.37104,39.59788c.73946.04621,2.07445-.75825,3.27621-.97285l-.06278,5.12176h10.92567l-.05774-4.43713c.34691.00139,1.41277,1.87036,1.40454,4.43713h2.60729c-.05361-1.85458-.66274-4.66678-1.79799-6.47016-.90846-2.00292-4.81954-3.07677-4.81954-3.07677-2.81302,1.8178-4.44397.48729-5.30236.05809,0,0-1.13088.65644-2.78264,1.3484-1.05868.44351-2.47513.7724-2.77547.27183-1.41635-2.36059-1.75971-4.23117-2.28905-6.82781-.45781-1.36986-2.42563-1.29688-2.41065.4435.57942,2.77906.99008,4.83623,2.21036,7.45373.71533,1.53437,1.18744,2.60737,1.87415,2.6503Z",
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.50397,20.5912c1.26659-.21395,2.56398.28566,2.7537,1.67893.09493.69717.08549,2.97073-.09455,3.60576-.58823,2.07473-3.85623,1.79071-4.15525-.12172-.09783-.6257-.08562-3.16867.04161-3.77313.12844-.61018.83159-1.28463,1.45448-1.38985h.00001ZM22.83211,21.46562c-.47194.08177-.84477.45814-.93025.93024-.09465.52278-.10326,2.50338-.01964,3.03092.18338,1.15682,2.13045,1.30351,2.37733.20193.10074-.44955.09352-2.86964.01663-3.36164-.10231-.65476-.85263-.90391-1.44408-.80145h.00001Z",
    fill: "#82368c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.81296,21.98711c-.03331-.04587-.67039.64112-.92843.65071-.43636.01621-.65803-.45997-.39142-.82277.05772-.07855,1.45277-1.15465,1.54292-1.19174.30982-.12746.60289-.08768.73935.23722l.01983,5.99233c-.13642.69405-.98224.41878-.98224.00228v-4.86803h-.00001Z",
    fill: "#82368c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37919,28.80397v.58652c.14663,2.4194,1.9795,4.39891,4.03234,4.39891,1.90619,0,3.59244-1.75956,3.95902-3.88571.80646.07331,1.61294-.36658,2.05283-1.02641l.21994-.29326-2.12614-1.02641c-.58652-2.49271-1.53962-2.93261-2.4194-3.3725-.87979-.51321-1.9795-.65983-3.00592-.36658-2.19946.51321-3.59244,2.78598-3.07923,4.98543,0,0,.36658,0,.36657,0ZM34.58457,28.58402h0c.29326.21994.51321.43989.73315.58652.36658.21994.73315.36658,1.09973.51321-.51321,1.46631-1.83288,2.85929-2.93261,2.85929-1.39298,0-2.63935-1.46631-2.78598-3.22587h0v-.43989c1.24636.14663,2.56603,0,3.88571-.29327h0Z",
    fill: "#82368c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.47859,30.89683h-8.36382c-1.61495,0-2.92874-1.31379-2.92874-2.92869v-8.36382c0-1.61489,1.31379-2.92869,2.92874-2.92869h8.36382c1.61484,0,2.92864,1.31379,2.92864,2.92869v8.36382c0,1.61489-1.31379,2.92869-2.92864,2.92869ZM17.11477,17.76956c-1.01168,0-1.8348.82307-1.8348,1.83475v8.36382c0,1.01168.82313,1.83475,1.8348,1.83475h8.36382c1.01168,0,1.8347-.82307,1.8347-1.83475v-8.36382c0-1.01168-.82302-1.83475-1.8347-1.83475,0,0-8.36382,0-8.36382,0Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgeUpIcon);
export default __webpack_public_path__ + "static/media/JudgeUpIcon.341e59eab78968415692ad2efd1fcab2.svg";
export { ForwardRef as ReactComponent };